import { Modal } from 'components/Modal';
import { CreateColourPaletteComponent } from './CreateColourPaletteComponent';

export const AddColourPalettesModal = ({ isOpen, setIsOpen }) => {
    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <Modal open={isOpen} onClose={handleClose} title="Create Colour Palette">
            <CreateColourPaletteComponent />
        </Modal>
    );
};
